(function() {
    function initWishlistButtons() {
        const containerSelector = '.product-loop.grid__wrapper';
        const container = document.querySelector(containerSelector);

        if (!container) {
            console.log('HULK-dp: Card container not found.');
            return;
        }

        const insertButton = (card) => {
            if (card.querySelector('.grid-wishlist-btn')) return;

            const innerContainer = card.querySelector('.spf-product-card__inner');
            if (!innerContainer) return;

            const reviewElement = card.querySelector('[product-id]');
            const productId = reviewElement ? reviewElement.getAttribute('product-id') : '';

            const variantElement = card.querySelector('select[name="id"].spf-product__variants');
            const variantId = variantElement ? variantElement.value : '';

            if (getComputedStyle(innerContainer).position === 'static') {
                innerContainer.style.position = 'relative';
            }

            const btnHTML = `
                <a href="javascript:void(0)" rel="nofollow" class="icon-wishlist-heart-empty wishlist-btn grid-wishlist-btn heart-wishlist-animation style_1" data-wishlist="" data-gridhulklist="" data-added="false" data-proid="${productId}" data-varid="${variantId}" style="color: rgb(74, 74, 74); display: inline-block !important; position: absolute; z-index: 99; right: 10px; top: 35px; left: unset;" data-custom-wishlist-icon="true">
                    <div style="display: initial;" class="wishlist_btn_icon">
                        <i class="heart-hulk-animation collection-icon" data-icon="outline" style="color: rgb(0, 0, 0); font-size: 16px; animation: auto ease 0s 1 normal none running none;"><i class="icon-wishlist-heart-empty"></i></i>
                    </div>
                    <span style="display: none;">Add to wishlist</span>
                    <span class="count" data-layout="top_count" style="background-color: rgb(0, 0, 0); color: rgb(255, 255, 255); display: none;">0</span>
                </a>
            `;

            innerContainer.insertAdjacentHTML('afterbegin', btnHTML);
        };

        const existingCards = container.querySelectorAll('.spf-product-card');
        existingCards.forEach(insertButton);

        let initTimeout;

        const observer = new MutationObserver((mutations) => {
            let hasNewCards = false;

            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            const cards = node.classList.contains('spf-product-card')
                                ? [node]
                                : Array.from(node.querySelectorAll('.spf-product-card'));

                            if (cards.length > 0) {
                                cards.forEach(insertButton);
                                hasNewCards = true;
                            }
                        }
                    });
                }
            });

            if (hasNewCards) {
                clearTimeout(initTimeout);
                
                initTimeout = setTimeout(() => {
                    if (typeof HulkappWishlist !== 'undefined' && typeof HulkappWishlist.init === 'function') {
                        HulkappWishlist.init();
                    }
                }, 100); 
            }
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWishlistButtons);
    } else {
        initWishlistButtons();
    }
})();